import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import BlogTemplate from "./BlogTemplate";
export default {
    key: "ARTICLES",
    label: "Blog",
    description: "Liste d'articles",
    templateImage: "/template-blog.png",
    Component: BlogTemplate,
    initialContents: [
        {
            key: "subpages",
            type: ContentsTypes.SUBPAGES_LIST,
            value: "",
            children: [],
        },
        {
            label: "dynamic",
            type: "DYNAMIC",
            dynamicChildKey: "dynamicElements",
            key: "dynamicPart",
            value: "",
            children: [
                {
                    key: "dynamicElements",
                    type: ContentsCustomTypes.CONTACT_BLOCK,
                    value: "",
                    children: [
                        {
                            children: [],
                            type: "INPUT",
                            value: "Un projet à lancer, une équipe à mobiliser ?",
                            key: "title",
                        },
                        {
                            children: [],
                            type: "INPUT",
                            value: "Bénéficiez d'un accompagnement global porté par une équipe d'experts engagés",
                            key: "subtitle",
                        },
                        {
                            children: [
                                {
                                    children: [],
                                    type: "INPUT",
                                    value: "/contact",
                                    key: "url",
                                },
                                {
                                    children: [],
                                    type: "INPUT",
                                    value: "Nous contacter",
                                    key: "title",
                                },
                                {
                                    children: [],
                                    type: "PAGE",
                                    key: "page",
                                    value: "",
                                },
                                {
                                    children: [],
                                    type: "CHECKBOX",
                                    key: "external",
                                    value: "false",
                                },
                            ],
                            type: "LINK",
                            key: "link",
                            value: "",
                        },
                    ],
                },
            ],
        },
    ],
};
